function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanonicalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 122,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.55 354.31c-11.28 0-21.75-2.02-31.43-6.06-9.68-4.04-18.09-9.93-25.24-17.67-7.15-7.74-12.79-17.29-16.91-28.65-4.13-11.36-6.18-24.36-6.18-39s2.23-27.64 6.69-39c4.46-11.36 10.39-20.91 17.8-28.65 7.4-7.74 15.99-13.59 25.75-17.54 9.76-3.95 19.94-5.93 30.54-5.93 6.56 0 12.53.42 17.92 1.26 5.38.84 10.1 1.89 14.14 3.16 4.04 1.26 7.49 2.52 10.35 3.79 2.86 1.26 5.05 2.4 6.56 3.41l-5.55 14.89c-4.21-2.52-9.55-5-16.03-7.45-6.48-2.44-14.51-3.66-24.11-3.66-10.94 0-20.49 1.85-28.65 5.55-8.16 3.7-15.02 8.92-20.57 15.65-5.55 6.73-9.72 14.73-12.5 23.98-2.78 9.26-4.17 19.52-4.17 30.8 0 11.28 1.39 22.09 4.17 31.43 2.78 9.34 6.86 17.29 12.24 23.86 5.38 6.56 11.99 11.61 19.82 15.15 7.83 3.53 16.79 5.3 26.88 5.3 11.11 0 20.4-1.05 27.89-3.16 7.49-2.1 13.17-4.25 17.04-6.44l4.8 14.64c-1.18.84-3.2 1.81-6.06 2.9-2.86 1.1-6.48 2.23-10.85 3.41-4.38 1.18-9.43 2.15-15.15 2.9-5.72.76-12.12 1.14-19.19 1.14ZM508.35 216.99c8.58 0 15.86 1.22 21.84 3.66 5.97 2.44 10.81 5.81 14.51 10.1 3.7 4.29 6.39 9.38 8.08 15.27 1.68 5.89 2.52 12.29 2.52 19.18v82.29c-1.68.5-4.13 1.05-7.32 1.64-3.2.59-6.9 1.22-11.11 1.89-4.21.67-8.88 1.22-14.01 1.64-5.14.42-10.39.63-15.78.63-6.9 0-13.25-.76-19.06-2.27-5.81-1.51-10.85-3.91-15.15-7.19-4.29-3.28-7.66-7.49-10.1-12.62-2.44-5.13-3.66-11.4-3.66-18.81 0-7.41 1.35-13.13 4.04-18.17 2.69-5.05 6.48-9.21 11.36-12.5 4.88-3.28 10.69-5.68 17.42-7.19 6.73-1.51 14.05-2.27 21.96-2.27 2.35 0 4.84.13 7.45.38 2.61.25 5.13.59 7.57 1.01 2.44.42 4.54.84 6.31 1.26 1.77.42 2.99.8 3.66 1.14v-8.08c0-4.54-.34-8.96-1.01-13.25-.67-4.29-2.15-8.16-4.42-11.61-2.27-3.45-5.47-6.22-9.59-8.33-4.13-2.1-9.55-3.16-16.28-3.16-9.59 0-16.75.67-21.46 2.02-4.71 1.35-8.16 2.44-10.35 3.28l-2.27-14.39c2.86-1.34 7.28-2.61 13.25-3.79 5.97-1.17 13.17-1.77 21.58-1.77Zm1.51 121.67c6.39 0 11.99-.21 16.79-.63 4.8-.42 8.87-.97 12.24-1.64v-45.94c-1.85-.84-4.8-1.72-8.84-2.65-4.04-.92-9.59-1.39-16.66-1.39-4.04 0-8.25.3-12.62.88-4.38.59-8.42 1.85-12.12 3.79-3.7 1.94-6.73 4.59-9.09 7.95-2.36 3.37-3.53 7.83-3.53 13.38 0 4.88.8 9 2.4 12.37 1.6 3.37 3.87 6.06 6.82 8.08 2.94 2.02 6.48 3.5 10.6 4.42 4.12.93 8.79 1.39 14.01 1.39ZM590.74 224.56c4.88-1.34 11.44-2.86 19.69-4.54 8.24-1.68 18.34-2.52 30.29-2.52 9.93 0 18.21 1.43 24.86 4.29 6.65 2.86 11.95 6.94 15.9 12.24 3.95 5.3 6.77 11.66 8.46 19.06 1.68 7.41 2.52 15.57 2.52 24.49v72.95h-16.41v-67.65c0-9.25-.63-17.08-1.89-23.48-1.26-6.39-3.37-11.61-6.31-15.65-2.95-4.04-6.82-6.94-11.61-8.71-4.8-1.77-10.81-2.65-18.05-2.65-7.74 0-14.43.42-20.07 1.26-5.64.84-9.3 1.6-10.98 2.27v114.6h-16.41V224.56ZM839.74 285.4c0 10.27-1.47 19.61-4.42 28.02-2.95 8.42-7.07 15.57-12.37 21.46-5.3 5.89-11.57 10.48-18.81 13.76-7.24 3.28-15.23 4.92-23.98 4.92s-16.75-1.64-23.98-4.92c-7.24-3.28-13.5-7.86-18.81-13.76-5.3-5.89-9.43-13.04-12.37-21.46-2.95-8.41-4.42-17.75-4.42-28.02s1.47-19.6 4.42-28.02c2.94-8.41 7.07-15.61 12.37-21.58 5.3-5.97 11.57-10.6 18.81-13.88 7.23-3.28 15.23-4.92 23.98-4.92s16.74 1.64 23.98 4.92c7.23 3.28 13.5 7.91 18.81 13.88 5.3 5.98 9.42 13.17 12.37 21.58 2.94 8.42 4.42 17.76 4.42 28.02Zm-17.42 0c0-16.32-3.79-29.32-11.36-39-7.57-9.68-17.84-14.51-30.8-14.51s-23.22 4.84-30.8 14.51c-7.57 9.68-11.36 22.68-11.36 39s3.79 29.28 11.36 38.88c7.57 9.59 17.84 14.39 30.8 14.39s23.22-4.8 30.8-14.39c7.57-9.59 11.36-22.55 11.36-38.88ZM869.29 224.56c4.88-1.34 11.44-2.86 19.69-4.54 8.24-1.68 18.34-2.52 30.29-2.52 9.93 0 18.21 1.43 24.86 4.29 6.65 2.86 11.95 6.94 15.9 12.24 3.95 5.3 6.77 11.66 8.46 19.06 1.68 7.41 2.52 15.57 2.52 24.49v72.95H954.6v-67.65c0-9.25-.63-17.08-1.89-23.48-1.26-6.39-3.37-11.61-6.31-15.65-2.95-4.04-6.82-6.94-11.61-8.71-4.8-1.77-10.81-2.65-18.05-2.65-7.74 0-14.43.42-20.07 1.26-5.64.84-9.3 1.6-10.98 2.27v114.6h-16.41V224.56ZM1025.97 180.64c0 3.87-1.18 6.94-3.53 9.21-2.36 2.27-5.22 3.41-8.58 3.41-3.36 0-6.23-1.14-8.58-3.41-2.36-2.27-3.53-5.34-3.53-9.21 0-3.87 1.18-6.94 3.53-9.21 2.35-2.27 5.21-3.41 8.58-3.41s6.22 1.14 8.58 3.41c2.36 2.27 3.53 5.34 3.53 9.21Zm-3.79 169.89h-16.41V220.02h16.41v130.51ZM1112.84 353.3c-10.1 0-19.02-1.6-26.76-4.8-7.74-3.2-14.18-7.78-19.31-13.76-5.14-5.97-9.05-13.13-11.74-21.46-2.69-8.33-4.04-17.54-4.04-27.64 0-10.1 1.39-19.6 4.17-28.02 2.78-8.41 6.77-15.65 11.99-21.71 5.21-6.06 11.53-10.73 18.93-14.01 7.4-3.28 15.73-4.92 24.99-4.92 7.07 0 13.67.59 19.82 1.77 6.14 1.18 10.89 2.69 14.26 4.54l-4.29 14.14c-3.37-1.68-7.15-3.03-11.36-4.04-4.21-1.01-9.84-1.51-16.91-1.51-14.47 0-25.46 4.67-32.94 14.01-7.49 9.34-11.23 22.59-11.23 39.76 0 7.74.84 14.85 2.52 21.33 1.68 6.48 4.42 12.03 8.2 16.66 3.79 4.63 8.67 8.25 14.64 10.85 5.97 2.61 13.25 3.91 21.83 3.91 7.07 0 13-.8 17.8-2.4 4.8-1.6 8.29-2.99 10.48-4.17l3.53 14.14c-3.03 1.68-7.79 3.33-14.26 4.92-6.48 1.6-13.25 2.4-20.32 2.4ZM1211.61 216.99c8.58 0 15.86 1.22 21.83 3.66 5.97 2.44 10.81 5.81 14.52 10.1 3.7 4.29 6.39 9.38 8.08 15.27 1.68 5.89 2.52 12.29 2.52 19.18v82.29c-1.68.5-4.13 1.05-7.32 1.64-3.2.59-6.9 1.22-11.11 1.89-4.21.67-8.88 1.22-14.01 1.64-5.13.42-10.39.63-15.78.63-6.9 0-13.25-.76-19.06-2.27-5.81-1.51-10.85-3.91-15.15-7.19-4.29-3.28-7.66-7.49-10.1-12.62-2.44-5.13-3.66-11.4-3.66-18.81 0-7.41 1.34-13.13 4.04-18.17 2.69-5.05 6.48-9.21 11.36-12.5 4.88-3.28 10.69-5.68 17.42-7.19 6.73-1.51 14.05-2.27 21.96-2.27 2.35 0 4.83.13 7.45.38 2.61.25 5.13.59 7.57 1.01 2.44.42 4.54.84 6.31 1.26 1.77.42 2.99.8 3.66 1.14v-8.08c0-4.54-.34-8.96-1.01-13.25-.67-4.29-2.15-8.16-4.42-11.61-2.27-3.45-5.47-6.22-9.59-8.33-4.13-2.1-9.55-3.16-16.28-3.16-9.59 0-16.75.67-21.46 2.02-4.71 1.35-8.17 2.44-10.35 3.28l-2.27-14.39c2.86-1.34 7.28-2.61 13.25-3.79 5.97-1.17 13.17-1.77 21.58-1.77Zm1.51 121.67c6.39 0 11.99-.21 16.79-.63 4.8-.42 8.87-.97 12.24-1.64v-45.94c-1.85-.84-4.8-1.72-8.83-2.65-4.04-.92-9.59-1.39-16.66-1.39-4.04 0-8.25.3-12.62.88-4.38.59-8.42 1.85-12.12 3.79-3.7 1.94-6.73 4.59-9.09 7.95-2.36 3.37-3.53 7.83-3.53 13.38 0 4.88.8 9 2.4 12.37 1.6 3.37 3.87 6.06 6.82 8.08 2.94 2.02 6.48 3.5 10.6 4.42 4.12.93 8.79 1.39 14.01 1.39ZM1326.74 352.8c-5.55-.17-10.39-.88-14.51-2.15-4.13-1.26-7.57-3.2-10.35-5.81-2.78-2.61-4.88-5.97-6.31-10.1-1.43-4.12-2.15-9.3-2.15-15.52V157.66l16.41-3.03v164.08c0 4.04.38 7.28 1.14 9.72.76 2.44 1.89 4.38 3.41 5.81 1.51 1.43 3.49 2.49 5.93 3.16 2.44.67 5.34 1.26 8.71 1.77l-2.27 13.63Z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#000",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 4.985 8.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 400V0h252.43v400z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#e95420",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 4.985 8.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 192.33V0h192.33v192.33z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 7.504 22.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.13C0 11.699 11.699 0 26.13 0s26.13 11.699 26.13 26.13-11.699 26.13-26.13 26.13S0 40.561 0 26.13z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 7.633 27.88)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.13C0 11.699 11.699 0 26.13 0s26.13 11.699 26.13 26.13-11.699 26.13-26.13 26.13S0 40.561 0 26.13z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 16.758 23.077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.66 321.53c-18.82-4.03-34.56-16.06-43.4-33.1a37.61 37.61 0 0 1-22.34 2.75c10.7 26.28 33.4 45.37 61.25 51.34a86.01 86.01 0 0 0 18.56 1.91 37.408 37.408 0 0 1-7.65-21.85c-2.15-.24-4.3-.59-6.41-1.04Z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 4.985 8.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.13C0 11.699 11.699 0 26.13 0s26.13 11.699 26.13 26.13-11.699 26.13-26.13 26.13S0 40.561 0 26.13z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 16.264 33.532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.03 312.08c8.13-10.24 13.85-22.35 16.61-35.23 4.81-22.44.32-45.99-12.32-65.09a37.644 37.644 0 0 1-14.7 17.21 63.952 63.952 0 0 1 6.04 43.39c-1.55 7.22-4.28 14.03-8.13 20.25a37.498 37.498 0 0 1 12.51 19.47ZM55.7 216.8c.66-.04 1.33-.05 1.99-.05 2.64 0 5.28.28 7.89.84 4.26.91 8.27 2.53 11.93 4.8 11.77-16.92 30.75-27.08 51.32-27.45.11-1.97.37-3.95.79-5.88a37.8 37.8 0 0 1 7.14-15.31c-32.86-2.6-64.8 14.36-81.06 43.05Z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#fff",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(.08384 0 0 .08384 4.985 8.754)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanonicalLogo);
export default __webpack_public_path__ + "static/media/canonical-logo.99cc3d9e695a9f21f690bbacf49bb210.svg";
export { ForwardRef as ReactComponent };